function JavascriptPayment() {
  return (
    <>
      <a
        href="https://paystack.com/pay/r90w84x1z3"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button
          style={{
            padding: "14px 40px",
            fontSize: 18,
            fontWeight: 600,
            borderRadius: 25,
            backgroundColor: "#0d6efd",
            borderColor: "#0d6efd",
            color: "#fff",
            textAlign: "center",
          }}
        >
          ₦ 50,000 ENROLL
        </button>
      </a>
    </>
  );
}

export default JavascriptPayment;
